class ParallaxGrid {
  constructor(root) {
    if (!root || !(root instanceof HTMLElement)) return;

    this.root = root;
    this.contentEl = root.querySelector('.parallax-grid__content');
    this.active = false;
    this.isInView = false;

    this.boundOnClick = this.onClick.bind(this);
    this.boundOnMouseEnter = this.onMouseEnter.bind(this);
    this.boundOnMouseMove = this.onMouseMove.bind(this);
    this.boundOnScroll = this.onScroll.bind(this);
    this.boundOnTouchStart = this.onTouchStart.bind(this);
    this.boundOnTouchMove = this.onTouchMove.bind(this);
    this.boundOnMouseLeave = this.onMouseLeave.bind(this);
    this.boundOnTouchEnd = this.onTouchEnd.bind(this);
    this.boundOnTouchCancel = this.onTouchCancel.bind(this);

    this.init();
  }

  get prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  get isDesktopPointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  deactivate() {
    this.active = false;
    if (this.contentEl) {
      this.contentEl.classList.remove('visible');
    }
    this.root.classList.remove('is-active');
  }

  activate() {
    this.active = true;
    this.root.classList.add('is-active');
    if (this.contentEl) {
      this.contentEl.classList.add('visible');
    }
  }

  onClick() {
    if (!this.isDesktopPointer || this.active || !this.isInView) return;
    this.activate();
  }

  onMouseEnter() {
    if (!this.isDesktopPointer || this.active || !this.isInView) return;
    this.activate();
  }

  onMouseMove() {
    if (!this.isDesktopPointer || this.active || !this.isInView) return;
    this.activate();
  }

  onScroll() {
    if (this.active || !this.isInView) return;
    this.activate();
  }

  onTouchStart() {
    if (this.isDesktopPointer || this.active || !this.isInView) return;
    this.activate();
  }

  onTouchMove() {
    if (this.isDesktopPointer || this.active || !this.isInView) return;
    this.activate();
  }

  onMouseLeave() {
    if (!this.isDesktopPointer || !this.active) return;
    this.deactivate();
  }

  onTouchEnd() {
    if (this.isDesktopPointer || !this.active) return;
    this.deactivate();
  }

  onTouchCancel() {
    if (this.isDesktopPointer || !this.active) return;
    this.deactivate();
  }

  init() {
    if (this.prefersReducedMotion) {
      this.activate();
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isInView = entry.isIntersecting;

        if (entry.isIntersecting) {
          return;
        }

        if (this.active) {
          this.deactivate();
        }
      });
    }, { threshold: 0.15 });

    this.observer.observe(this.root);
    this.root.addEventListener('click', this.boundOnClick);
    this.root.addEventListener('mouseenter', this.boundOnMouseEnter);
    this.root.addEventListener('mousemove', this.boundOnMouseMove);
    window.addEventListener('scroll', this.boundOnScroll, { passive: true });
    this.root.addEventListener('touchstart', this.boundOnTouchStart, { passive: true });
    this.root.addEventListener('touchmove', this.boundOnTouchMove, { passive: true });
    this.root.addEventListener('mouseleave', this.boundOnMouseLeave);
    this.root.addEventListener('touchend', this.boundOnTouchEnd, { passive: true });
    this.root.addEventListener('touchcancel', this.boundOnTouchCancel, { passive: true });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.root.removeEventListener('click', this.boundOnClick);
  this.root.removeEventListener('mouseenter', this.boundOnMouseEnter);
  this.root.removeEventListener('mousemove', this.boundOnMouseMove);
  window.removeEventListener('scroll', this.boundOnScroll);
    this.root.removeEventListener('touchstart', this.boundOnTouchStart);
  this.root.removeEventListener('touchmove', this.boundOnTouchMove);
    this.root.removeEventListener('mouseleave', this.boundOnMouseLeave);
    this.root.removeEventListener('touchend', this.boundOnTouchEnd);
    this.root.removeEventListener('touchcancel', this.boundOnTouchCancel);

    this.deactivate();
  }
}

window.ParallaxGrid = ParallaxGrid;